// Qual desenho a tela de atendimentos usa. É preferência de quem está
// usando, não configuração da empresa: dois atendentes na mesma conta podem
// querer telas diferentes, e mudar a sua não muda a de ninguém.
//
// Fica no mesmo cookie de preferências do tema e do modo do menu — valor
// curto, lido antes de qualquer requisição para a tela já nascer certa.
import { lerPreferencia, gravarPreferencia } from "./preferencias";
import api from "./api";

export const CHAVE_LAYOUT_TICKETS = "layout:tickets";

export const LAYOUTS_TICKETS = [
	{
		id: "classico",
		nome: "Clássico",
		resumo: "Lista ao lado da conversa",
		detalhe:
			"O de sempre: lista de cartões à esquerda, conversa à direita. Boa quando você acompanha a lista enquanto responde.",
	},
	{
		id: "foco",
		nome: "Foco",
		resumo: "Uma conversa por vez",
		detalhe:
			"Ao abrir um atendimento a lista sai da tela e a conversa ocupa tudo. Voltar para a lista é o botão à esquerda do nome ou a tecla Esc.",
	},
	{
		id: "painel",
		nome: "Painel",
		resumo: "Lista em grade, mais linhas na tela",
		detalhe:
			"A lista vira grade de uma linha por atendimento — cabe o triplo na tela. Sem selo colorido: cor só para quem está esperando demais. Boa para quem cobre vários departamentos.",
	},
];

const ehValido = (valor) => LAYOUTS_TICKETS.some((l) => l.id === valor);

export const lerLayoutTickets = () => {
	const valor = lerPreferencia(CHAVE_LAYOUT_TICKETS, "classico");
	return ehValido(valor) ? valor : "classico";
};

// Aviso na mesma aba: o `storage` do navegador só dispara para OUTRAS abas, e
// aqui quem troca (Configurações) e quem obedece (a tela de atendimentos)
// podem estar montados ao mesmo tempo.
export const EVENTO_LAYOUT_TICKETS = "layout-tickets:mudou";

export const gravarLayoutTickets = (valor) => {
	if (!ehValido(valor)) return;
	gravarPreferencia(CHAVE_LAYOUT_TICKETS, valor);
	window.dispatchEvent(new CustomEvent(EVENTO_LAYOUT_TICKETS));

	// A escolha também vai para o usuário, para seguir a pessoa quando ela
	// trocar de máquina. Falhar aqui não desfaz nada: o cookie já respondeu e a
	// tela já mudou — a preferência só não atravessa navegadores.
	api.put("/users/me/tickets-layout", { ticketsLayout: valor }).catch(() => {});
};

// O layout guardado no usuário, quando a sessão volta. O cookie continua sendo
// quem responde primeiro (a tela precisa nascer certa antes de qualquer
// requisição); isto só alinha a máquina nova com o que a pessoa escolheu na
// antiga — e por isso pode haver uma troca visível no primeiro carregamento
// dessa máquina, uma vez só.
export const aplicarLayoutDoUsuario = (usuario) => {
	const valor = usuario?.ticketsLayout;

	if (!ehValido(valor) || valor === lerLayoutTickets()) return;

	gravarPreferencia(CHAVE_LAYOUT_TICKETS, valor);
	window.dispatchEvent(new CustomEvent(EVENTO_LAYOUT_TICKETS));
};
